import "@king-ict/eupisi-ui/styles/theme.scss";
import "@openfonts/source-sans-pro_latin-ext";

import { StrictMode, Suspense } from "react";

import { keycloakInstance } from "@king-ict/eupisi-ui/auth";
import { ReactKeycloakProvider } from "@king-ict/eupisi-ui/components";
import { Spinner } from "@king-ict/eupisi-ui/components";
import { hr } from 'date-fns/locale';
import { registerLocale } from "react-datepicker";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";

import "./index.css";
import App from "./app/App";
import store from "./app/store";
import reportWebVitals from "./reportWebVitals";

import "./app/i18n";
registerLocale('hr', hr);

ReactDOM.render(
  <StrictMode>
    <ReactKeycloakProvider
      authClient={keycloakInstance}
      LoadingComponent={<Spinner show={true} />}
    >
      <Provider store={store}>
        <Router>
          <Suspense fallback={<Spinner show={true} />}>
            <App />
          </Suspense>
        </Router>
      </Provider>
    </ReactKeycloakProvider>
  </StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
